<template>
  <div>
    <div class="lianXiWoMen">
      <div ref="fromBtn" class="fromBtn">
        <img src="../assets/guanyuwomen/from.png" alt="">
      </div>
      <div class="wx">
        <img src="../assets/guanyuwomen/wx.png" alt="">
      </div>
    </div>
    <div class="fromBox animated animate__animated" ref="fromBox">
      <div class="close" @click="closeBox">
        <van-icon name="cross" />
      </div>
      <h1>合作表单</h1>
      <p>请仔细填写下方信息，我们的专业客服会马上联系到您您将得到第一手的信息资料和合作说明。</p>
      <div class="form" ref="form">
        <input v-model="formData.name" type="text" placeholder="1、项目名称（中文）">
        <input v-model="formData.name_english" type="text" placeholder="2、项目名称（英文）  ">
        <input v-model="formData.website" type="text" placeholder="3、项目官网网站">
        <input v-model="formData.leader" type="text" placeholder="4、项目负责人">
        <input v-model="formData.leader_tel" type="text" placeholder="5、联系电话（必填）">
        <textarea v-model="formData.introduction" placeholder="6、项目简介"/>
      </div>
      <div class="submit" @click="submit">立刻联系</div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import 'animate.css'
import {
  Toast
} from 'vant'
export default {
  name: 'ContactUS',
  data() {
    return {
      formData: {
        name: '',
        name_english: '',
        website: '',
        leader: '',
        leader_tel: '',
        introduction: ''
      }
    }
  },
  created () {
    window.addEventListener('scroll', (ev) => {
      let top = document.documentElement.scrollTop
      let lianXiWoMen = document.querySelector('.lianXiWoMen')
      // 滚动视口高度(也就是当前元素的真实高度)
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      // 可见区域高度
      let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      // 滚动条顶部到浏览器顶部高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      if(top >= 500) lianXiWoMen.classList.add('isShowWx')
      if(top < 500 ) lianXiWoMen.classList.remove('isShowWx')
      if(clientHeight + scrollTop >= scrollHeight - 305) lianXiWoMen.classList.remove('isShowWx')
    })
  },
  mounted () {
    let fromBtn = this.$refs.fromBtn
    let fromBox = this.$refs.fromBox
    let from = this.$refs.form
    fromBtn.addEventListener('mouseover',() => {
      fromBox.style.display = 'block';
    })
    Array.from(from.children).map(item => {
      item.addEventListener('input', (e) => {
        if (e.target.value !== '') item.classList.add('isInput')
        if (e.target.value === '') item.classList.remove('isInput')
      })
    })
  },
  methods: {
    closeBox() {
      this.$refs.fromBox.style.display = 'none'
      this.formData = {
        name: '',
        name_english: '',
        website: '',
        leader: '',
        leader_tel: '',
        introduction: ''
      }
    },
    async submit(){
      let phoneReg = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      if(!this.formData.name) return Toast('中文项目名称不能为空！');
      if(!this.formData.name_english) return Toast('英文项目名称不能为空！');
      if(!this.formData.website) return Toast('项目官网不能为空！');
      if(!this.formData.leader) return Toast('项目负责人不能为空！');
      if(!this.formData.leader_tel) return Toast('电话不能为空！');
      if(!phoneReg.test(this.formData.leader_tel)) return Toast('电话格式错误！');
      if(!this.formData.introduction) return Toast('项目介绍不能为空！');
      let {data} = await axios.post('http://39.98.249.37:5001/api/create', this.formData)
      if(data.status === -1) return Toast('添加失败!');
      Toast('请等候我们电联!');
      this.closeBox()
    }
  }
}
</script>

<style scoped lang="less">
@keyframes myfirst {
  0%   {
    transform: scale(0);
    right: 0;
  }
  100% {
    transform: scale(1) translateX(50%);
  }
}
.fromBtn{
  margin: 0 auto 10px;
  left: 50%;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #7045FF;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  padding: 20px;
  box-sizing: border-box;
  img{
    width: 100%;
    height: 100%;
  }
  &:hover{
    cursor: pointer;
  }
}
.wx{
  width: 150px;
  height: 285px;
  img{
    width: 100%;
    height: 100%;
  }
}
.fromBox{
  animation: myfirst 1s ease-in-out ;
  display: none;
  position: fixed;
  top: 20%;
  right: 50%;
  transform: translateX(50%);
  width: 400px;
  height: 580px;
  background-color: white;
  box-shadow: 0px 0px 20px rgba(153, 153, 153, 0.3);
  z-index: 99;
  border-radius: 20px;
  background-image: url("../assets/guanyuwomen/fromBg.png");
  background-repeat: no-repeat;
  background-size: 100%;
  .close{
    position: absolute;
    font-size: 20px;
    right: -10px;
    top: -10px;
    color: #FFFFFF;
    background-color: rgba(0,0,0,.3);
    width: 40px;
    line-height: 40px;
    height: 40px;
    border-radius: 50%;
    box-sizing: border-box;
    padding-left: 12px;
    &:hover{
      cursor: pointer;
    }
  }
  h1{
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 26px;
    text-align: center;
    color: #FFFFFF;
    margin-top: 25px;
  }
  p{
    padding: 0 20px;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    color: #7045FF;
    margin-top: 40px;
  }
  .form{
    padding: 23px 33px;
    box-sizing: border-box;
    width: 100%;
    input{
      width: 334px;
      height: 30px;
      margin-bottom: 10px;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #999999;
      padding: 0 12px;
      box-sizing: border-box;
      border: none;
      background-color: #F5F5F5;
      border-radius: 10px;
    }
    textarea{
      width: 334px;
      height: 100px;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #999999;
      padding: 12px;
      box-sizing: border-box;
      border: none;
      background-color: #F5F5F5;
      border-radius: 10px;
      resize: none;
    }
  }
  .submit{
    width: 301px;
    height: 50px;
    margin: 0 auto;
    background: #7045FF;
    border-radius: 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 50px;
    color: #FFFFFF;
    text-align: center;
    &:hover{
      cursor: pointer;
    }
  }
}
.lianXiWoMen{
  display: none;
  width: 150px;
  height: 420px;
  position: fixed;
  z-index: 999999;
  bottom: 0px;
  right: 50px;
}
.isShowWx{
  display: block;
}
.isInput{
  border:1px solid #333 !important;
  color: #333 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ContactUS.vue